module.exports = __webpack_public_path__ + "img/outer-9.f5bd0896.png";